<template>
	<div class="card">
		<div class="card-header">
	      <div>
	          <div class="d-flex mb-3">
	              <div>
	                  <el-dropdown @command="changeBDRank">
	                    <span class="el-dropdown-link">
	                      {{ BDRankTitle }}<i class="el-icon-arrow-down el-icon--right"></i>
	                    </span>
	                    <el-dropdown-menu slot="dropdown">
	                      <el-dropdown-item command="daily">{{ $t('dashboard.bd-rank.daily') }}</el-dropdown-item>
	                      <el-dropdown-item command="weekly">{{ $t('dashboard.bd-rank.weekly') }}</el-dropdown-item>
	                    </el-dropdown-menu>
	                  </el-dropdown>
	              </div>
	              <span class="flex"></span>
	              <div>
	                  
	              </div>
	          </div>
	      </div>
		</div>
		<div class="card-body">
			<div class="chart-wrapper">
				<Chart id="bd-rank" :options="options" />
			</div>
		</div>
	</div>
</template>
<style>
.chart-wrapper {
  height: 400px;
}
</style>
<script>
// @ is an alias to /src
import Chart from '@/components/dashboard/Chart.vue'
import moment from 'moment'

export default {
  name: 'BDRank',
  components: {
    Chart
  },
  data: function() {
    return {
      bdData: null,
      options: null,
      currentReport: 'daily'
    }
  },
  computed: {
    BDRankTitle: function() {
      if (this.currentReport === 'daily') 
        return this.$t('dashboard.bd-rank.daily')
      else if (this.currentReport === 'weekly')
        return this.$t('dashboard.bd-rank.weekly')
    }
  },
  methods: {
    changeBDRank: function(command) {
      this.currentReport = command
      this.setChart(this.currentReport)
    },
    async loadData () {
      try {
        let query = '?userId=' + localStorage.getItem('token'),
          res = await this.$http.get(this.API_PREFIX + 'bd_rank' + query)
        return res.data
      } catch (err) {
        console.log(err)
      }
    },
    setChart: function(reportType) {
      let that = this
      this.options = {
        color: ['#3398DB'],
        tooltip: {},
        grid: {containLabel: true},
        xAxis: {
          type: 'value'
        },
        yAxis: {
          type: 'category',
          data: []
        },
        series: [{
          type: 'bar',
          data: []
        }]
      }
      this.clientData.then(function (response) {
        let d = null,
            tmp = [],
            name = []
        //console.log(response)
        if (that.currentReport === 'daily') 
          d = response.daily
        else if (that.currentReport === 'weekly')
          d = response.weekly
        
        //console.log(d)
        for (var c in d) {
          //console.log(d[c].user)
          //that.options.yAxis.data.push(d[c].name)
          name.push(d[c].name)
          tmp.push(d[c].num)
        }
        that.options.yAxis.data = name.reverse()
        that.options.series.push({
          type: 'bar',
          data: tmp.reverse()
        })
        //console.log(that.options)
      }).catch(function (error) {
        console.log(error)
      })
    }
  },
  created: function() {
    this.clientData = this.loadData()
  },
  mounted: function() {
    this.setChart()
  }
}
</script>